import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './tokens.css';
import './estilos.css';

/*
 * Sin `QueryClientProvider` aquí: cada sesión trae el suyo (`sesion.ts`). Uno
 * solo para toda la pestaña es lo que dejaba ver el almacén del negocio
 * anterior después de cambiar de cuenta.
 */
const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('Falta el nodo raíz');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
